import type {Relation} from "typeorm";
import {Column, Entity, OneToMany} from "typeorm";
import {BaseEntity} from "./BaseEntity";
import {Max, MaxLength, Min} from "class-validator";
import {Country} from "@/modules/base/entity/Country";
import {RegionEnum} from "@/modules/base/enums";

@Entity()
export class Region extends BaseEntity {
  @Column({type: 'varchar', length: '50'})
  @MaxLength(50)
  name: RegionEnum;

  @OneToMany(() => Country, country => country.region)
  countries: Relation<Country[]>;

  @Column({type: 'float'})
  @Min(0)
  @Max(100)
  newPlayerProgress = 0;

  // percentage of players which play abroad in other regions, e.g. 10 => 10% of all foreigners in country are from this region
  @Column({type: 'integer'})
  percentageAbroad = 0;
}
